// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../img/graphics/noise.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pin__container {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 7;
  width: 100vw;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.pin__container .pin-code {
  padding: 0;
  margin: 0 auto;
  display: flex;
  justify-content: center;
}
.pin__container .pin-code input {
  border: none;
  text-align: center;
  width: 48px;
  height: 48px;
  font-size: 36px;
  background-color: #F3F3F3;
  margin-right: 5px;
  border: 1px solid rgba(0, 0, 0, 0);
}
.pin__container .pin-code input:focus {
  border: 2px solid rgba(150, 0, 0, 0.99);
  outline: none;
}
.pin__container .pin__infoTop {
  margin-bottom: 20px;
  height: 20px;
  font-size: 14px;
  font-weight: 300;
  letter-spacing: 3px;
  opacity: 0.5;
}
.pin__container .pin__infoBottom {
  margin-top: 20px;
  height: 20px;
  font-size: 14px;
  font-weight: 300;
  letter-spacing: 3px;
}
.pin__container input::-webkit-outer-spin-button,
.pin__container input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.pin__background {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 5;
  width: 100vw;
  background: rgba(33, 33, 33, 0.75);
}
.pin__noiseBackground {
  position: fixed;
  z-index: 6;
  top: -50%;
  left: -50%;
  right: -50%;
  bottom: -50%;
  width: 200%;
  height: 200vh;
  background: transparent url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: 50%;
  animation: bg-animation 0.2s infinite;
  opacity: 0.9;
}
@keyframes bg-animation {
  0% {
    transform: translate(0, 0);
  }
  10% {
    transform: translate(-5%, -5%);
  }
  20% {
    transform: translate(-10%, 5%);
  }
  30% {
    transform: translate(5%, -10%);
  }
  40% {
    transform: translate(-5%, 15%);
  }
  50% {
    transform: translate(-10%, 5%);
  }
  60% {
    transform: translate(15%, 0);
  }
  70% {
    transform: translate(0, 10%);
  }
  80% {
    transform: translate(-15%, 0);
  }
  90% {
    transform: translate(10%, 5%);
  }
  100% {
    transform: translate(5%, 0);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/PinInput/PinInput.less"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AACJ;AAXA;EAaQ,UAAA;EACA,cAAA;EACA,aAAA;EACA,uBAAA;AACR;AAjBA;EAkBY,YAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,iBAAA;EACA,kCAAA;AAEZ;AADY;EACI,uCAAA;EACA,aAAA;AAGhB;AA/BA;EAkCQ,mBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;AAAR;AAvCA;EA2CQ,gBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AADR;AA9CA;;EAoDQ,wBAAA;EACA,SAAA;AAFR;AAMA;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,YAAA;EACA,kCAAA;AAJJ;AAOA;EACI,eAAA;EACA,UAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,+DAAA;EACA,oBAAA;EACA,qCAAA;EACA,YAAA;AALJ;AAMI;EACE;IAAK,0BAAA;EAHT;EAII;IAAM,8BAAA;EADV;EAEI;IAAM,8BAAA;EACV;EAAI;IAAM,8BAAA;EAGV;EAFI;IAAM,8BAAA;EAKV;EAJI;IAAM,8BAAA;EAOV;EANI;IAAM,4BAAA;EASV;EARI;IAAM,4BAAA;EAWV;EAVI;IAAM,6BAAA;EAaV;EAZI;IAAM,6BAAA;EAeV;EAdI;IAAO,2BAAA;EAiBX;AACF","sourcesContent":[".pin__container {\n    position: fixed;\n    top: 0;\n    left: 0;\n    z-index: 7;\n    width: 100vw;\n    text-align: center;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n\n    .pin-code { \n        padding: 0; \n        margin: 0 auto; \n        display: flex;\n        justify-content:center;\n        input { \n            border: none; \n            text-align: center; \n            width: 48px;\n            height:48px;\n            font-size: 36px; \n            background-color: #F3F3F3;\n            margin-right:5px;\n            border: 1px solid rgba(0, 0, 0, 0);\n            &:focus { \n                border: 2px solid rgba(150, 0, 0, .99);\n                outline: none;\n            } \n        } \n    } \n      \n    .pin__infoTop {\n        margin-bottom: 20px;\n        height: 20px;\n        font-size: 14px;\n        font-weight: 300;\n        letter-spacing: 3px;\n        opacity: .5;\n    }\n      \n    .pin__infoBottom {\n        margin-top: 20px;\n        height: 20px;\n        font-size: 14px;\n        font-weight: 300;\n        letter-spacing: 3px;\n    }\n\n    input::-webkit-outer-spin-button,\n    input::-webkit-inner-spin-button {\n        -webkit-appearance: none;\n        margin: 0;\n    }\n}\n\n.pin__background {\n    position: fixed;\n    top: 0;\n    left: 0;\n    z-index: 5;\n    width: 100vw;\n    background: rgba(33,33,33, .75);\n}\n\n.pin__noiseBackground {\n    position: fixed;\n    z-index: 6;\n    top: -50%;\n    left: -50%;\n    right: -50%;\n    bottom: -50%;\n    width: 200%;\n    height: 200vh;\n    background: transparent url('../../img/graphics/noise.png');\n    background-size: 50%;\n    animation: bg-animation .2s infinite;\n    opacity: .9;\n    @keyframes bg-animation {\n      0% { transform: translate(0,0) }\n      10% { transform: translate(-5%,-5%) }\n      20% { transform: translate(-10%,5%) }\n      30% { transform: translate(5%,-10%) }\n      40% { transform: translate(-5%,15%) }\n      50% { transform: translate(-10%,5%) }\n      60% { transform: translate(15%,0) }\n      70% { transform: translate(0,10%) }\n      80% { transform: translate(-15%,0) }\n      90% { transform: translate(10%,5%) }\n      100% { transform: translate(5%,0) }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
